import alt from 'framework/alt';
import CsrfTokenActions from 'actions/CsrfTokenActions';

class CsrfTokenStore {
  constructor() {
    this.state = {
      token: undefined,
    };

    this.on('bootstrap', () => {
      const { csrftoken } = this.state;

      this.setState({
        token: csrftoken.token,
      });
    });

    this.bindListeners({
      setToken: CsrfTokenActions.setToken,
    });
  }

  setToken(token) {
    this.setState({ token });
  }
}

export default alt.createStore(CsrfTokenStore, 'CsrfTokenStore');
